<div class="row">
    <div class="col-12">
    <!-- <div [ngClass]="{'col-8':showStatusBox, 'col-12':!showStatusBox}"> -->
        <div class="collapsable-container">
            <div class="collapsable-container-header" (click)="collapsed = !collapsed">
                <div class="heading">
                    <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
                    <span class="fa fa-filter"></span> Filter: {{ FilterDescription }}
                </div>
            </div>
            <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed}">
                <div class="row mt-3 ml-1">
                    <div class="col-12">
                        <form [formGroup]="filterFormGroup" class="">
                            <div class="row">
                                <div class="col-lg-2">
                                    <!-- Filter -->
                                    <div class="form-group row">
                                        <div class="col-lg-12">
                                            <yt-fw-date-picker-popup formControlName="DateFrom"
                                                [Label]="'FILTER.FROM-DATE'">
                                            </yt-fw-date-picker-popup>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group row">
                                        <div class="col-lg-12">
                                            <yt-fw-date-picker-popup formControlName="DateTo"
                                                [Label]="'FILTER.TO-DATE'">
                                            </yt-fw-date-picker-popup>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-4">
                                    <div class="form-group row">
                                        <div class="col-lg-12">
                                            <yt-multiselect
                                            [ModelName]="'orgjed'"
                                            [GetName]="'getParentAndChildByParentID'"
                                            [ModelProperty]="'Naziv'"
                                            [OrderBy]="'Naziv'"
                                            formControlName="OrgJedIDS"
                                            [AllowAddNew]="false" 
                                            [Type]="'ID'"
                                            [Label]="'FILTER.ORGJED'"                
                                            (onSelect)="SelectOrgJed($event)"
                                            (GetItems)="SkupiOrgJed($event)">
                                        </yt-multiselect>
                                        </div>
                                    </div>
                                </div>
                                <div class="mr-2">
                                    <button
                                     type="button"
                                     (click)="ApplyFilter()"
                                     class="btn btn-secondary"
                                     ngbTooltip="{{'FILTER.APPLYFILTER.TOOLTIP' | translate }}"
                                    >
                                        <span class="fa fa-search"></span>
                                    </button>
                                </div>
                                <div class="mr-2">
                                    <button type="button" (click)="ResetFilter()" class="btn btn-secondary"
                                        ngbTooltip="{{'FILTER.RESETFILTER.TOOLTIP' | translate }}">
                                        <span class="fa fa-undo"></span>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- </div> -->
    <!-- <div *ngIf="showStatusBox" class="col-4">
        <div class="collapsable-container">
            <div class="collapsable-container-header" (click)="collapsed1 = !collapsed1">
                <div class="heading">
                    <span class="btn-collapse"><span class="fa fa-fw fa-angle-double-down"></span></span>
                    <span class="fas fa-sync-alt"></span> Status: {{ StatusDescription }}
                </div>
            </div>
            <div class="collapsable-container-content" [ngClass]="{'collapsed': collapsed1}">
                <div class="row  mt-4 ml-1 pt-1">
                    <div class="col-12">
                        <form [formGroup]="filterFormGroup" class="">
                            <div class="row">
                                <div class="col-6">
                                    <div class="form-group row mt-1">
                                        <div class="col-lg-12">
                                            Osveži status za dokumenta stara do
                                        </div>
                                    </div>
                                </div>
                                <div class="col-2">
                                    <div class="input-group">
                                        <input
                                         formControlName="DanaZaOsvezavanje"
                                         type="number"
                                         min="0"
                                         step="1"
                                         class="form-control"
                                         placeholder="Broj dana"
                                        >
                                    </div>                                
                                </div>
                                <div class="col-lg-2">
                                    <div class="form-group row mt-1">
                                        <div class="col-lg-12">
                                            dana
                                        </div>
                                    </div>
                                </div>                                
                                <div class="col-2">
                                    <div class="form-group row">
                                        <div class="col-lg-12">
                                            <button
                                             class="btn btn-secondary"
                                             type="button"
                                             (click)="RefreshStatusClick()"
                                             ngbTooltip="{{'FAKDOKUMENT.OSVEZISTATUS.ACTION' | translate }}"
                                            >
                                                <span class="fas fa-sync-alt"></span>
                                            </button>
                                        </div>
                                    </div>
                                </div>                                
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div> -->
</div>